<script>
    import R, {LOADER} from "../lib/requests";
    import {HOTEL_TYPE} from "../lib/constants.js";
    import app from "../stores/app";
    import user from "../stores/user.js";
    import Alert from "../stores/alerts.js";
    import {dateAfter, getDate} from "../lib/lib.js";
    import CalendarControl from "../components/controls/CalendarControl.svelte";
    import BirthdayControl from "../components/controls/BirthdayControl.svelte";
    import PhoneControl from "../components/controls/PhoneControl.svelte";
    import LastNameControl from "../components/controls/LastNameControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import PageInfo from "../components/pages/PageInfo.svelte";
    import PersonAllergies from "../components/PersonAllergies.svelte";


    export let checkinHotel = null;

    let hotel = null;
    let member = null;
    let hotels = null;
    let villas = null;
    let allergens = null;
    let countries = null;
    let checkIn = null;
    let loginDenied = false;
    let completed = false;
    // let phoneErrors = [];
    let phoneErrors = {};
    let emailErrors = [];

    const emptyPerson = () => {
        return {
            member_id: 0,
            abbr: '',
            lastname: '',
            firstname: '',
            birthday: null,
            phone: '',
            email: '',
            address: '',
            city: '',
            zip: '',
            country_id: '',
            passport_id: '',
            allergies: [],
        }
    }

    const initialize = (loader = LOADER.PAGE) => {
        const onSuccess = result => {
            allergens = result.allergens;
            member = result.member;
            if (result.hotels) {
                result.hotels.map(item => {
                    if (item.type == HOTEL_TYPE.HOTEL) {
                        if (!hotels) hotels = [];
                        hotels.push(item);
                    } else {
                        if (!villas) villas = [];
                        villas.push(item);
                    }
                })
            }
            hotel = result.hotel;
            countries = result.countries;

            checkIn = {
                member_id: member ? member.id : 0,
                hotel_id: hotel ? hotel.id : '',
                date_in: getDate(),
                date_out: null,
                persons: []
            }

            if (member) {
                checkIn.persons.push({
                    id: 0,
                    member_id: member.id,
                    abbr: member.abbr,
                    lastname: member.lastname,
                    firstname: member.firstname,
                    birthday: member.birthday,
                    phone: member.phone,
                    email: member.email,
                    address: member.address,
                    city: member.city,
                    zip: member.zip,
                    passport_id: member.passport_id,
                    country_id: member.country_id,
                    allergies: [],
                });
            } else {
                checkIn.persons.push(emptyPerson());
            }
            checkIn.persons.push(emptyPerson());
        }

        const onFailure = err => {
        };

        R.handle(R.checkIn.initialize, {hotel: checkinHotel}, onSuccess, onFailure, loader);
    }

    const onPhoneChange = index => {
        // check if phone is in use by an other person
        delete (phoneErrors[index]);

        let phone = checkIn.persons[index].phone;
        let personIndex = 0;
        checkIn.persons.map(item => {
            if (personIndex != index && item.phone == phone) {
                phoneErrors[index] = true;
            }
            personIndex++;
        });
        phoneErrors = phoneErrors;
    }

    const onEmailChange = index => {
        delete (emailErrors[index]);
        // check if email is in use by an other person
        let email = checkIn.persons[index].email;
        let personIndex = 0;
        checkIn.persons.map(item => {
            if (personIndex != index && item.email == email) {
                emailErrors[index] = true;
            }
            personIndex++;
        });

        emailErrors = emailErrors;

        if ($user.token || index > 0 || loginDenied) {
            return;
        }
        if (checkIn.persons[0].email) {
            findByEmail(checkIn.persons[0].email);
        }
    }

    const hasError = (arr, index) => {
        return arr.indexOf(index) > -1;
    }

    const onAddPerson = () => {
        checkIn.persons = [...checkIn.persons, emptyPerson()];
    }

    const onRemovePerson = index => {
        delete (phoneErrors[index]);
        phoneErrors = phoneErrors;

        delete (emailErrors[index]);
        emailErrors = emailErrors;

        checkIn.persons.splice(index, 1);
        checkIn.persons = checkIn.persons;
    }

    const findByEmail = email => {

        const onSuccess = result => {
            if (result.member == 1) {
                Alert.confirm(
                    "Member account",
                    "It appears that you are a member of the Enorme Loyalty Club.\nDo you wish to Log in to your account to receive your hotel Check In points?",
                    user.showLogin,
                    () => loginDenied = false
                );
            }
        }

        const onFailure = err => {
        };

        // R.handle(R.member.find, email, onSuccess, onFailure, LOADER.NONE);
    }

    const submit = () => {

        const onSuccess = result => {
            completed = true;
            if ($app.debugNotifications) {
                Alert.alert("DEBUG!", `Hotel Receptionnist gets this link on his email:\n<a href="${result.link}" target="_blank">${result.link}</a>`);
            }
        }

        const onFailure = err => {
            Alert.alert("Check in", "Fill in all required fields to proceed!");
        };

        // TODO - Check post data!
        if (Object.keys(phoneErrors).length > 0) {
            Alert.alert("Check in", "It looks like you have used the same phone number for more than one person.\nEach person on the list must have their own phone number!");
            return;
        }

        if (Object.keys(emailErrors).length > 0) {
            Alert.alert("Check in", "It looks like you have used the same email address for more than one person.\nEach person on the list must have their own email address!");
            return;
        }

        R.handle(R.checkIn.create, checkIn, onSuccess, onFailure, LOADER.POPUP);
    }

    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('hotel')) {
        checkinHotel = searchParams.get('hotel');
    }

    initialize();
</script>

<div class="page-header solid">
    <h1>On-Line Check in</h1>
</div>
<div class="page page-padding" class:solid={completed}>
    <div class="checkin-wrapper">
        {#if !completed}
            {#if !$user.token}
                <div class="d-flex align-items-center gap-2 fs-5 mb-3">
                    <span class="fs-bold ">Are you a member?</span>
                    <button class="btn btn-link fs-5 p-0" on:click={ user.showLogin }>Sign in</button>
                </div>
            {/if}
            <p>
                All data will be respected according the GDPR statement as per below.
            </p>
            <p>
                Please keep in mind that in the context of improving our offered services, we might email you a link
                with a form to determine the degree of satisfaction for each client that stayed in our hotel.
            </p>
            {#if checkIn}
                <form on:submit|preventDefault|stopPropagation="{ submit }">
                    <div class="panel-simple panel-pad box-shadow rounded mb-4">
                        {#if hotel}
                            <div class="small">Hotel</div>
                            <h3 class="mb-4">{ hotel.name }</h3>
                        {:else}
                            <div class="form-group">
                                <label for="hotel" class="text-gray small">Hotel *</label>
                                <select class="form-select" id="hotel" bind:value="{ checkIn.hotel_id }" required>
                                    <option value="" disabled>Select your hotel</option>
                                    {#each hotels as hotel}
                                        <option value="{ hotel.id }">{ hotel.name }</option>
                                    {/each}
                                </select>
                            </div>
                        {/if}

                        <div class="row">
                            <div class="col-6 form-group">
                                <label for="checkin" class="text-gray small">Check-in *</label>
                                <CalendarControl bind:date="{ checkIn.date_in }" hideClear/>
                            </div>
                            <div class="col-6 form-group">
                                <label for="checkout" class="text-gray small">Check-out *</label>
                                <CalendarControl bind:date="{ checkIn.date_out }"
                                                 startDate="{ dateAfter(checkIn.date_in, 1) }"
                                                 openRight hideToday hideClear required/>
                            </div>
                        </div>

                        {#each checkIn.persons as person, index}
                            <div class="person">
                                <div class="panel-section justify-content-between my-4">
                                    <div class="section-line"></div>
                                    <div class="title pe-2">
                                        PERSON { index + 1 }
                                        {#if index == 0}
                                            (YOU)
                                        {/if}
                                    </div>
                                    {#if index > 0}
                                        <div class="section-content ps-2">
                                            <button class="btn-generic text-danger fw-semibold d-flex align-items-center"
                                                    title="remove person { index + 1 }"
                                                    on:click={ () => onRemovePerson(index) }>
                                                <AppIcon icon="user-minus-solid" cssClass="me-1" size="16"/>
                                                (remove)
                                            </button>
                                        </div>
                                    {:else}
                                        {#if !member}
                                            <button class="btn-generic login text-success fw-semibold d-flex align-items-center"
                                                    title="login"
                                                    on:click={ user.showLogin }>
                                                I am a member
                                                <AppIcon icon="sign-in" cssClass="ms-1" size="16"/>
                                            </button>
                                        {/if}
                                    {/if}
                                </div>

                                {#if person.member_id > 0}
                                    <h4 class="mb-3">{ person.lastname } { person.firstname }</h4>
                                {:else}
                                    <div class="row">
                                        <div class="col-md-6 form-group">
                                            <label for="lastname-{index}" class="text-gray small">Last name *</label>
                                            <LastNameControl bind:abbr="{ person.abbr }"
                                                             bind:lastname="{ person.lastname }" required/>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label for="firstname-{index}" class="text-gray small">First name *</label>
                                            <input type="text" id="firstname-{index}" class="form-control"
                                                   bind:value="{ person.firstname }"
                                                   required>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 form-group">
                                            <label for="birthday-{index}" class="text-gray small">Birthday *</label>
                                            <BirthdayControl bind:value="{ person.birthday }" required/>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label for="nationality-{index}" class="text-gray small">
                                                Nationality *
                                            </label>
                                            <select id="nationality-{index}" class="form-select"
                                                    bind:value="{ person.country_id }" required>
                                                <option value="" disabled>select</option>
                                                {#each countries as country}
                                                    <option value="{ country.id }">{ country.name }</option>
                                                {/each}
                                            </select>
                                        </div>
                                    </div>
                                {/if}

                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label for="phone-{index}" class="text-gray small">
                                            Phone { index == 0 ? '*' : '' }
                                        </label>
                                        <PhoneControl id="phone-{index}" bind:value="{ person.phone }"
                                                      on:change={() => onPhoneChange(index)}
                                                      disabled="{ person.member_id > 0 }" required="{ index == 0 }"/>
                                        {#if phoneErrors[index]}
                                            <div class="text-danger small">
                                                This number is registered to another person!
                                            </div>
                                        {/if}
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label for="email-{index}" class="text-gray small">
                                            Email *
                                        </label>
                                        <input type="email" id="email-{index}" class="form-control"
                                               bind:value="{ person.email }"
                                               on:change="{ () => onEmailChange(index) }"
                                               disabled="{ person.member_id > 0 }" required>
                                        {#if emailErrors[index]}
                                            <div class="text-danger small">
                                                This email is registered to another person!
                                            </div>
                                        {/if}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label for="address-{index}" class="text-gray small">
                                            Address { index == 0 ? '*' : '' }
                                        </label>
                                        <input type="text" id="address-{index}" class="form-control"
                                               bind:value="{ person.address }"
                                               required="{ index == 0 }">
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label for="city-{index}" class="text-gray small">
                                            City { index == 0 ? '*' : '' }
                                        </label>
                                        <input type="text" id="city-{index}" class="form-control"
                                               bind:value="{ person.city }"
                                               required="{ index == 0 }">
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label for="zip-{index}" class="text-gray small">
                                            Zip { index == 0 ? '*' : '' }
                                        </label>
                                        <input type="text" id="zip-{index}" class="form-control"
                                               bind:value="{ person.zip }"
                                               required="{ index == 0 }">
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label for="passport-{index}" class="text-gray small">Passport Id *</label>
                                        <input type="text" id="passport-{index}" class="form-control"
                                               bind:value="{ person.passport_id }"
                                               required>
                                    </div>
                                </div>

<!--                                <div class="text-gray small mb-1">Do you have any allergies?</div>-->
                                <!--                                <div class="small mb-1">Select any allergies that apply</div>-->
                                <div class="text-gray small mb-1">Food allergies</div>
                                <PersonAllergies {allergens} bind:selected={person.allergies}
                                                 bind:preferences={person.food_preferencies}/>
                            </div>
                        {/each}
                        <div class="text-center my-4">
                            <a href="#" class="btn btn-default px-3"
                               on:click|preventDefault|stopPropagation={ onAddPerson }>
                                <span class="d-flex">
                                    <AppIcon icon="user-plus-solid" size="16" cssClass="me-2"/>
                                    add person
                                </span>
                            </a>
                        </div>
                        <hr class="my-4">
                        {#if !$user.token}
                            <div class="form-check mb-4">
                                <input class="form-check-input" type="checkbox" value="" id="checkTerms" required>
                                <label class="form-check-label" for="checkTerms">
                                    By clicking this checkbox you acknowledge that your personal information will be
                                    used in accordance to our
                                    <a href="https://www.enormehotels.com/en/privacy-policy.php" target="_blank">
                                        privacy policy
                                    </a>
                                </label>
                            </div>
                        {/if}
                        <div class="text-end">
                            <button class="btn btn-primary px-4">Submit</button>
                        </div>
                    </div>
                </form>
            {/if}
        {:else}
            <PageInfo type="success" icon="check" title="Checkin Completed!" showDashboard/>
        {/if}
    </div>
</div>

<style>
    .checkin-wrapper {
        max-width: 700px;
    }

    .login {
        z-index: 200;
        background: #fff;
        padding-left: 5px;
    }
</style>